import { useSelector } from "react-redux";
import { membershipLens, RENTAL_INTENT, flagsAndExperimentNames } from "rtr-constants";
import { getRentalIntent } from "helpers/rental-intent-helper";
import { useOnLoadFlagOrExperiment } from "components/source/hoc/with-flags-and-experiments";
import { isSSR } from "helpers/client-server-helper";

export const MIN_INNER_HEIGHT = 700;

export function useShowGridProductDrawer() {
  const [showNewPDPDrawer] = useOnLoadFlagOrExperiment(flagsAndExperimentNames.NEW_GRID_PDP_DRAWER);
  const [doNotShowMobileDrawer] = useOnLoadFlagOrExperiment(flagsAndExperimentNames.RSV_1426_MOBILE_DRAWER_EXPERIMENT);
  const isMobileViewport = useSelector(state => state.browser?.isMobileViewport);
  const currentIntent = useSelector(state => getRentalIntent(state?.userData));
  const url = useSelector(s => s?.initialUrl);
  const gridType = useSelector(state => state.nextGridType);
  const isBuyNow = useSelector(state => state.isBuyNow);

  // Do not use drawer on smaller devices, the PDP images are too large for it to be useful
  if (!isSSR() && window.innerHeight < MIN_INNER_HEIGHT) {
    return false;
  }

  if (isMobileViewport && doNotShowMobileDrawer) {
    return false;
  }

  if (currentIntent === RENTAL_INTENT.RESERVE && gridType !== "clearance" && !isBuyNow) {
    return false;
  }

  if (url) {
    const queryString = url.split("?")[1];
    if (queryString) {
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.get("lens") === membershipLens.classic) return false;
    }
  }

  return showNewPDPDrawer;
}
